import { render } from "./letter-compose.vue?vue&type=template&id=369e8ff2"
import script from "./letter-compose.vue?vue&type=script&lang=js"
export * from "./letter-compose.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__